import { Table, TableProps } from 'antd';
import clsx from 'clsx';
import { ReactElement, ReactNode } from 'react';

import { EmptyState } from '../empty-state';
import styles from './styles.module.scss';

type TTableProps<T> = TableProps<T> & {
    emptyContent?: ReactNode;
};

export const CustomTable = <T,>({
    emptyContent = 'No data',
    ...props
}: TTableProps<T>): ReactElement => {
    return (
        <Table
            rowHoverable={false}
            rowKey="id"
            {...props}
            className={clsx(styles.table, props.className)}
            locale={{
                emptyText: <EmptyState content={emptyContent} />,
                ...props.locale,
            }}
            showSorterTooltip={false}
            pagination={{
                position: ['bottomCenter'],
                hideOnSinglePage: true,
                showSizeChanger: false,
                ...props.pagination,
            }}
            scroll={{ y: 65 * 10, ...props.scroll }}
        />
    );
};
